/**
 * Détection du type de coach — point UNIQUE, partagé client + serveur.
 *
 * Contexte (régression 16/06/2026) : le routage des coachs (Debrief / Prepa) se faisait
 * en comparant le `name` du simulateur à un libellé en dur ("Coach Debrief", "Coach Prepa").
 * Or le `name` est éditable via la modale admin → renommé "Debrief Meeting" / "Prepa Meeting"
 * → tous les matchs cassaient (mauvais parcours, fiche simulateur au lieu du coach).
 *
 * On tolère ici les renommages en matchant le mot-clé métier. Couvre les libellés connus :
 *   - Debrief : "Debrief Meeting", "Coach Debrief", "Sales Coach Réel/Reel"
 *   - Prepa   : "Prepa Meeting", "Coach Prepa", "Prep Meeting"
 *
 * ⚠️ DETTE — solution de fond à venir : ajouter une colonne STABLE `code` (ex "DEBRIEF"/"PREPA")
 * sur `simulators`, non éditable par la modale, seedée identique sur tous les envs, et router
 * dessus. Quand ce sera fait, il suffira de remplacer l'implémentation de cette fonction
 * (les appelants n'auront pas à changer).
 */
export type CoachKind = "debrief" | "prepa" | null;

export function detectCoachKind(
  name: string | null | undefined,
  simulatorType?: string | null,
): CoachKind {
  // Si le type est connu et n'est pas un coach, ce n'est jamais un coach Debrief/Prepa.
  if (simulatorType && simulatorType !== "coach") return null;
  const n = (name || "").toLowerCase();
  if (n.includes("debrief") || n.includes("sales coach r")) return "debrief";
  if (n.includes("prepa") || n.includes("prep meeting")) return "prepa";
  return null;
}
